/* ERA v6 — traînée de poudre de fée, version adoucie (-20 % de particules).
   Copie de assets/era-paillettes.js ; seules 2 valeurs changent :
   - MAX 500 -> 400 (plafond de particules à l'écran) ;
   - densité le long du trajet : même calcul, puis × 0,8 (arrondi aléatoire,
     donc exactement -20 % en moyenne, même sur les petits mouvements).
   Taille, durée de vie, lueur et couleurs inchangées.
   Désactivée sur mobile/tablette (pas de souris) et si l'utilisateur a demandé
   à réduire les animations. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAX = 400;
  /* teintes de la poudre : blanc chaud -> or */
  var TINTS = [
    [255, 226, 110], [250, 205, 70], [240, 180, 35], [225, 155, 20], [205, 135, 10]
  ];
  /* or plus soutenu sur les bords du halo : la poudre reste lumineuse
     sur les fonds crème du site, pas seulement sur fond sombre */
  var AMBER = '200,130,10';

  var canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483646';
  document.body.appendChild(canvas);
  var ctx = canvas.getContext('2d');
  var dpr = 1, w = 0, h = 0;

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = window.innerWidth; h = window.innerHeight;
    canvas.width = w * dpr; canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  /* --- sprites pré-dessinés (rapide à afficher) --- */
  function sprite(size, draw) {
    var c = document.createElement('canvas');
    c.width = c.height = size * 2;
    var g = c.getContext('2d');
    g.scale(2, 2);
    draw(g, size / 2);
    return c;
  }

  /* point lumineux : cœur blanc-doré + halo or */
  function makeDot(t) {
    return sprite(32, function (g, r) {
      var grd = g.createRadialGradient(r, r, 0, r, r, r);
      grd.addColorStop(0, 'rgba(255,255,240,1)');
      grd.addColorStop(0.16, 'rgba(255,240,170,1)');
      grd.addColorStop(0.32, 'rgba(' + t + ',0.95)');
      grd.addColorStop(0.55, 'rgba(' + AMBER + ',0.4)');
      grd.addColorStop(1, 'rgba(' + AMBER + ',0)');
      g.fillStyle = grd;
      g.fillRect(0, 0, r * 2, r * 2);
    });
  }

  /* croix scintillante : 4 rayons fins + petit halo */
  function makeGlint(t) {
    return sprite(48, function (g, r) {
      var halo = g.createRadialGradient(r, r, 0, r, r, r * 0.45);
      halo.addColorStop(0, 'rgba(255,255,240,1)');
      halo.addColorStop(0.3, 'rgba(' + t + ',0.8)');
      halo.addColorStop(1, 'rgba(' + AMBER + ',0)');
      g.fillStyle = halo;
      g.fillRect(0, 0, r * 2, r * 2);
      g.translate(r, r);
      for (var k = 0; k < 2; k++) {
        var ray = g.createLinearGradient(-r, 0, r, 0);
        ray.addColorStop(0, 'rgba(' + AMBER + ',0)');
        ray.addColorStop(0.3, 'rgba(' + t + ',0.9)');
        ray.addColorStop(0.5, 'rgba(255,255,240,1)');
        ray.addColorStop(0.7, 'rgba(' + t + ',0.9)');
        ray.addColorStop(1, 'rgba(' + AMBER + ',0)');
        g.fillStyle = ray;
        g.beginPath();
        g.moveTo(-r, 0); g.lineTo(0, -r * 0.08); g.lineTo(r, 0); g.lineTo(0, r * 0.08);
        g.closePath();
        g.fill();
        g.rotate(Math.PI / 2);
      }
    });
  }

  var DOTS = TINTS.map(function (c) { return makeDot(c.join(',')); });
  var GLINTS = TINTS.slice(0, 3).map(function (c) { return makeGlint(c.join(',')); });
  var GLOW = sprite(96, function (g, r) {
    var grd = g.createRadialGradient(r, r, 0, r, r, r);
    grd.addColorStop(0, 'rgba(255,245,190,0.95)');
    grd.addColorStop(0.25, 'rgba(245,190,50,0.5)');
    grd.addColorStop(1, 'rgba(' + AMBER + ',0)');
    g.fillStyle = grd;
    g.fillRect(0, 0, r * 2, r * 2);
  });

  var parts = [];
  var mouse = null, last = null, glow = 0;
  var running = false;

  function rand(a, b) { return a + Math.random() * (b - a); }

  function spawn(x, y, dx, dy) {
    if (parts.length >= MAX) parts.shift();
    var glint = Math.random() < 0.18;
    parts.push({
      x: x + rand(-5, 5),
      y: y + rand(-5, 5),
      /* hérite un peu du mouvement de la souris, puis flotte */
      vx: dx * 0.06 + rand(-0.35, 0.35),
      vy: dy * 0.06 + rand(-0.5, 0.15),
      sway: rand(0, Math.PI * 2),
      swaySpeed: rand(0.03, 0.07),
      size: glint ? rand(18, 30) : rand(4, 12),
      img: glint ? GLINTS[(Math.random() * GLINTS.length) | 0] : DOTS[(Math.random() * DOTS.length) | 0],
      glint: glint,
      twinkle: rand(0, Math.PI * 2),
      twinkleSpeed: glint ? rand(0.25, 0.45) : rand(0.08, 0.2),
      life: 1,
      decay: rand(0.006, 0.014)
    });
  }

  function frame() {
    ctx.clearRect(0, 0, w, h);

    /* lueur de luciole à la pointe, qui s'éteint quand la souris s'arrête */
    if (mouse && glow > 0.01) {
      var gs = 34 + glow * 18;
      ctx.globalAlpha = glow * 0.75;
      ctx.drawImage(GLOW, mouse.x - gs / 2, mouse.y - gs / 2, gs, gs);
      glow *= 0.9;
    }

    for (var k = parts.length - 1; k >= 0; k--) {
      var p = parts[k];
      p.sway += p.swaySpeed;
      p.vx *= 0.97;
      p.vy = p.vy * 0.97 + 0.018;          /* retombe doucement */
      p.x += p.vx + Math.sin(p.sway) * 0.25; /* flotte de gauche à droite */
      p.y += p.vy;
      p.twinkle += p.twinkleSpeed;
      p.life -= p.decay;
      if (p.life <= 0 || p.y > h + 20) { parts.splice(k, 1); continue; }

      var tw = 0.55 + 0.45 * Math.sin(p.twinkle);
      var s = p.size * (p.glint ? (0.5 + 0.5 * tw) : (0.6 + 0.4 * p.life));
      ctx.globalAlpha = Math.min(1, p.life * 1.4) * (p.glint ? tw : 0.6 + 0.4 * tw);
      ctx.drawImage(p.img, p.x - s / 2, p.y - s / 2, s, s);
    }
    ctx.globalAlpha = 1;

    if (parts.length || glow > 0.01) requestAnimationFrame(frame);
    else { running = false; ctx.clearRect(0, 0, w, h); }
  }

  window.addEventListener('mousemove', function (e) {
    var x = e.clientX, y = e.clientY;
    mouse = { x: x, y: y };
    if (last) {
      var dx = x - last.x, dy = y - last.y;
      var dist = Math.hypot(dx, dy);
      if (dist > 1) {
        glow = Math.min(1, glow + dist / 40);
        /* une poussière dense, répartie le long du trajet */
        var n = Math.min(14, Math.ceil(dist / 3.5));
        n = Math.floor(n * 0.8 + Math.random()); /* -20 % de particules, en moyenne exacte */
        for (var j = 0; j < n; j++) {
          var t = Math.random();
          spawn(last.x + dx * t, last.y + dy * t, dx, dy);
        }
      }
    }
    last = { x: x, y: y };
    if (!running) { running = true; requestAnimationFrame(frame); }
  }, { passive: true });

  document.addEventListener('mouseleave', function () { last = null; mouse = null; });
})();
